import { call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* startProcess(action: ActionInterface): any {
  try {

    if( action.payload.process == "createChargesForContracts") {
      yield call(Http.post, `process/createChargesForContracts`);
    }

    if( action.payload.process == "mailChargesWithoutOwnerStatement") {
      yield call(Http.post, `process/mailChargesWithoutOwnerStatement`);
    }

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

  }
}

export function* watchStartProcess() {
  yield takeEvery(Constants.START_PROCESS, startProcess);
}
